<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="字典名称" prop="name">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <a-form-model-item label="字典编码" prop="code">
      <a-input v-model="form.data.code"/>
    </a-form-model-item>
    <a-form-model-item label="是否有效" prop="isActive">
      <a-radio-group :v-model="form.data.isActive">
        <a-radio value="YES">
          有效
        </a-radio>
        <a-radio value="NO">
          无效
        </a-radio>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item label="备注" prop="remark">
      <a-input
        type="textarea"
        autosize
        v-model="form.data.remark">
      </a-input>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!dictionaryId" @click="onAdd">{{ $t('CREATE') || '创建' }}</a-button>
        <a-button type="primary" v-if="dictionaryId" @click="onUpdate">{{ $t('UPDATE') || '创建' }}</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _addDictionary,
  _queryDictionary,
  _queryAllDictionaries,
  _updateDictionary,
} from '@/api/sys/sysDictionaryApi';

async function getDictionary() {
  const result = await _queryDictionary(this.dictionaryId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.code = result.code;
    this.form.data.isActive = result.isActive;
    this.form.data.remark = result.remark;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      this.form.disabled = true;
      const result = await _addDictionary({
        name: this.form.data.name,
        code: this.form.data.code,
        isActive: this.form.data.isActive,
        remark: this.form.data.remark,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

async function onUpdate() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateDictionary(this.dictionaryId, {
        name: this.form.data.name,
        code: this.form.data.code,
        isActive: this.form.data.isActive,
        remark: this.form.data.remark,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          if (this.onSubmitHandler) {
            this.onSubmitHandler();
          }
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'DictionaryEdit',
  props: {
    dictionaryId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    dictionaryId(val) {
      if (val) {
        this.getDictionary();
      }
      this.form.data = {
        name: '',
        code: '',
        isActive: 'YES',
        remark: '',
      };
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getDictionary,
  },
  data() {
    const checkCode = async (rule, value, callback) => {
      const result = await _queryAllDictionaries({ code: value });
      if (result.length > 0 && result[0].id !== this.dictionaryId) {
        callback(new Error('编码已存在'));
      }
    };
    return {
      dictionary: {
        data: [],
        tree: [],
      },
      form: {
        data: {
          name: '',
          code: '',
          isActive: 'YES',
          remark: '',
        },
        rules: {
          name: [{
            required: true,
            message: '请输入字典名称',
            trigger: 'blur',
          }],
          code: [{
            required: true,
            message: '请输入字典编码',
            trigger: 'blur',
          }, {
            validator: checkCode,
            trigger: 'blur',
          }],
        },
        disabled: false,
        title: '',
      },
    };
  },
  created() {
    if (this.dictionaryId) {
      this.getDictionary();
    }
  },
};
</script>
